import { graphql } from "msw";
import allUsers from "../data/users/allUsers";
import { getItemFromStore, setItemToStore } from "@odm/utils/utils";

export const handlers = [
  graphql.query("getLoggedInUser", (req, res, ctx) => {
    // alert("11");
    return res(
      ctx.data({
        getLoggedInUser: {
          id: "f7ba2024-c170-407f-acab-9f00d37cc8bb",
          userName: "e10596",
          displayName: "Carlos Ibrahim (Consultant)",
          emailAddress: "e10596@isdb.onmicrosoft.com",
          status: "Active",
          avatarUrl: null,
          roles: ["WAHubAdmin"],
          country: {
            code: "LB",
            name: "Lebanon",
          },
          organization: "Noema",
          jobTitle: "Functional Consultant",
          telephone: null,
          phoneNumber: null,
          settings: {
            preferredLanguage: "en",
            defaultCurrency: {
              code: "USD",
              name: "US Dollar",
            },
            timezone: "Asia/Beirut",
            theme: "light",
            notifications: {
              chat: "Always",
              task: "Always",
            },
          },
        },
      })
    );
  }),

  graphql.mutation("updateUser", (req, res, ctx) => {
    const {
      id,
      countryCode,
      organization,
      jobTitle,
      telephone,
      preferredLanguage,
      defaultCurrency,
      timezone,
    } = req.variables;

    setItemToStore("language", preferredLanguage);

    return res(
      ctx.delay(1000),
      ctx.status(200),
      ctx.data({
        message: "Updated Successfully",
        updateUser: {
          id: id,
          country: {
            code: countryCode,
          },
          organization: organization,
          jobTitle: jobTitle,
          telephone: telephone,
          settings: {
            preferredLanguage: preferredLanguage,
            defaultCurrency: defaultCurrency,
            timezone: timezone,
          },
        },
      })
    );
  }),

  graphql.mutation("findUsers", (req, res, ctx) => {
    const { q, page, size } = req.variables; // eslint-disable-line no-unused-vars
    return res(
      ctx.data({
        findUsers: [
          {
            displayName: "Anastasios Georgousakis",
            emailAddress: "e2008@isdb.onmicrosoft.com",
          },
          {
            displayName: "Jean-Paul Davoutian",
            emailAddress: "e2066@isdb.onmicrosoft.com",
          },
          {
            displayName: "Krishna Prakash",
            emailAddress: "e10635@isdb.onmicrosoft.com",
          },
          {
            displayName: "Naman Anand",
            emailAddress: "e10636@isdb.onmicrosoft.com",
          },
          {
            displayName: "Panos Karvelas",
            emailAddress: "e10637@isdb.onmicrosoft.com",
          },
        ],
      })
    );
  }),
];
